resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function APIModelException(type, message) {
    this.type = name;
    this.message = message;
}